export const DomParser = new DOMParser();
export const FRONTEND_VERSION = import.meta.env.VITE_BUILD_VERSION;
export const APPLICATION_RIBBON_ENTITY_NAME = '_talxis_application_ribbon';
export const DEFAULT_BODY_MAIN_BACKGROUND_COLOR = '#faf9f8';
export const SCRIPT_ISOLATION = false;